<template>
    <div class="header-container">
        <div class="header">
            <div class="nav-btn fl" @click="isNavShow = !isNavShow">
                <i class="icon iconfont icon-menu" v-show="!isNavShow"></i>
                <i class="icon iconfont icon-guanbi" style="font-weight:bold" v-show="isNavShow"></i>
            </div>
            <div class="logo">
                <img src="https://cdn1.p2ipo.com/pc/home/jdzc-logo1.png" alt>
                <span class="title">上市孵化器</span>
            </div>
        </div>
        <div class="nav-mask" id="navMask" v-show="isNavShow" @click="isNavShow = !isNavShow">
            <div class="nav">
                <ul id="nav">
                    <li v-for="(item, i) in navMenuList" :key="i" :id="item.page" 
                        :class="{isactive:menuActive==i}" @click.stop="listenNav(i)">{{item.name}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '@/common/eventBus.js';
export default {
    name: 'headersM',
    data() {
        return {
            navMenuList: [
                { name: '首页', path: '/homeM', page: 'homeM' },
                { name: '挂牌企业', path: '/listedM', page: 'listedM' },
                { name: '孵化基地', path: '/incubatorM', page: 'incubatorM' },
                { name: '产业集群', path: '/baseM', page: 'baseM' },
                { name: '与投资者关系', path: '/investorM', page: 'InvestorM' },
                { name: '企业社会责任', path: '/dutyM', page: 'DutyM' },
                { name: '系统规则', path: '/ruleM', page: 'RuleM' }
            ],
            isNavShow: false,
            menuActive: 0,
            navMaskHeight: 0
        }
    },
    mounted() {
        // 获取导航遮罩层高度
        this.getNavMaskHeight();
    },
    watch: {
        isNavShow(newVal, oldVal) {
            if(newVal) {
                let val = window.sessionStorage.getItem("menuActive");
                if(val) {
                    this.menuActive = JSON.parse(val).menuStatus;
                }
            }
        }
    },
    methods: {
        getNavMaskHeight() {
            this.navMaskHeight = document.documentElement.clientHeight - 60;
            document.getElementById('navMask').style.height = this.navMaskHeight / 100 + 'rem';
        },
        listenNav(i) {
            this.menuActive = i;
            if(i === 1) {
                let data = {
                    searchData: '',
                    scaleId: 0,
                    typeOne: '',
                    typeTwo: '',
                    typeThree: '',
                    typeFour: ''
                };
                window.sessionStorage.setItem('m_listed_serch_data', JSON.stringify(data));
                data = null;
            }
            if(i === 2) {
                let data = {
                    searchData: '',
                    areaData: '区域',
                    streetData: '街道',
                    page: 1
                };
                window.sessionStorage.setItem('m_incubator_serch_data', JSON.stringify(data));
                data = null;
            }
            let menuActive = {
                menuStatus: this.menuActive
            };
            window.sessionStorage.setItem("menuActive", JSON.stringify(menuActive));
            this.isNavShow = false;
            this.$router.push({path: this.navMenuList[i].path});
        },
    }
}
</script>
<style lang="scss" scoped>
@import './HeadersM.scss';
</style>


// WEBPACK FOOTER //
// src/components/mobile/common/headers/HeadersM.vue